import { heroCovers, trendTicker } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 pt-10 md:pt-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 animate-fade-up">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-50 text-primary-700 px-3 py-1 text-xs font-semibold tracking-wide whitespace-nowrap">
              <span className="flex h-2 w-2 rounded-full bg-primary-500 animate-pulse-dot" />
              今日头版 · 翻车实录馆
            </div>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-black leading-[1.15] tracking-tight text-foreground-950">
              全网翻车现场
              <span className="text-primary-500">，一页看完</span>
            </h1>
            <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              收录直播与舞台上的名场面、翻车瞬间与翻车合集。每一次被回放、被截图、被补刀的十秒，都被好好存档在这里——吃瓜群众，欢迎入馆。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3 pb-1">
            <a
              href="#rank"
              className="inline-flex items-center gap-2 rounded-full bg-foreground-950 text-background-50 px-5 py-2.5 text-sm font-semibold whitespace-nowrap hover:bg-foreground-800"
            >
              查看本周热度榜
              <i className="ri-arrow-right-up-line text-base" />
            </a>
            <a
              href="#moments"
              className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 text-foreground-800 px-5 py-2.5 text-sm font-semibold whitespace-nowrap hover:border-foreground-300 hover:bg-background-100"
            >
              名场面大赏
            </a>
          </div>
        </div>

        <div className="mt-10 overflow-hidden rounded-lg border-y border-background-200 bg-background-100 py-3">
          <div className="flex">
            <div className="ticker-track items-center gap-10">
              {[...trendTicker, ...trendTicker].map((item, idx) => (
                <span key={idx} className="flex items-center gap-3 text-sm font-medium text-foreground-600">
                  <i className="ri-fire-line text-primary-500" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 py-8 md:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
          {heroCovers.map((c, idx) => (
            <a
              href="#archive"
              key={c.title}
              className={`group card-lift flex flex-col overflow-hidden rounded-xl bg-background-100 border border-background-200 animate-fade-up delay-${idx + 1}`}
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.title}，51大雷翻车名场面`}
                  className="group-img h-full w-full object-cover object-top"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/80 text-background-50 px-2.5 py-1 text-[11px] font-semibold backdrop-blur-sm whitespace-nowrap">
                  {c.tag}
                </span>
                <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-play-fill text-sm" />
                </span>
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background-950/75 to-transparent editorial-mask" />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
                  {c.title}
                </h3>
                <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-price-tag-3-line" />
                    {c.source}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line" />
                    {c.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}